import { styled } from 'linaria/react';

import { theme } from '../Theme';

const Container = styled('div')`
  display: flex;
  flex-wrap: wrap;
  justify-content: space-between;
  max-width: 72.5rem;
  padding: 3.5rem 0rem;
  width: 100%;

  ${theme.below.lg} {
    width: 100%;
  }
  ${theme.below.md} {
    padding-top: 0.5rem;
  }
`;

const Heading = styled('h1')`
  font-size: 1.75em;
  font-weight: 300;
  margin-bottom: 5px;
  text-align: center;
  text-transform: uppercase;
`;

const SubHeading = styled('h2')`
  margin-bottom: 10px;
`;

const ArticleNumber = styled('p')`
  line-height: 23px;
  font-size: 13px;
  color: #969696;
  margin-bottom: 20px;
`;

const ShortDescription = styled('article')`
  color: black;

  font-size: 14px;
  font-weight: 300;
  line-height: 1.6;
  margin-bottom: 1rem;

  p {
    margin-bottom: 1rem;
  }
`;

const ProductContainer = styled('div')`
  display: flex;
  align-items: center;
  flex-direction: column;
  justify-content: space-between;
  margin: 0 auto;
  max-width: 72.5rem;
  padding: 0;

  h2 {
    color: black;

    font-size: 12pt;
    font-weight: 300;
    letter-spacing: 1;
    margin: 1em 0;
    overflow: hidden;
    text-align: center;
    text-transform: uppercase;
    width: 100%;
    padding-top: 2px;
    ${theme.below.md} {
      margin: 0.25em 0;
    }
    &:before,
    &:after {
      background: #eaeaea;
      content: '';
      display: inline-block;
      height: 1px;
      margin-top: -3px;
      position: relative;
      vertical-align: middle;
      width: 50%;
    }
    &:before {
      right: 0.5em;
      margin-left: -50%;
    }
    &:after {
      left: 0.5em;
      margin-right: -50%;
    }
  }
`;

const ProductDetailsWrapper = styled('div')`
  display: flex;
  flex-direction: column;
  align-items: center;
  width: 35%;
  ${theme.below.lg} {
    padding-right: 1rem;
  }

  ${theme.below.md} {
    padding: 0 1rem;
    width: 100%;
  }

  img {
    margin-bottom: 1rem;
    max-width: 100%;
  }

  table {
    color: black;
    font-famiy: Helvetica, sans-serif;
    font-size: 14px;
  }
  th {
    text-transform: uppercase;
  }
  td {
    font-weight: 300;
  }

  ${theme.above.md} {
  }

  .price {
    color: black;
    font-size: 1.8em;
    font-weight: 600;
    margin-bottom: 1rem;
  }
  .price {
    font-size: 1.5rem;
    ${theme.below.sm} {
      font-size: 1.25rem;
    }
  }
`;
export {
  Container,
  Heading,
  SubHeading,
  ArticleNumber,
  ShortDescription,
  ProductContainer,
  ProductDetailsWrapper
};
